import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { TabsState, Tabs, Tab } from '../Tabs';
import GeographicDestinationsTab from './GeographicDestinationsTab';
import SectorsEarningsTab from './SectorsEarningsTab';
import EmployeeMatchReportTab from './EmployeeMatchReportTab';
import EmployeeMethodologyTab from './EmployeeMethodologyTab';
import { loadEmployeeReport, loadEmployeeSharedReport, downloadEmployeeDataFiles, setTab2_bullets } from '../../../actions/EmployeeReportActions';
import DisclaimerOverlay from "./DisclaimerOverlay";
import { UserEmployeeReportState, EmployeeReportAction } from '../../../interface/EmployeeReportInterface';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';
import ViewReportModal from '../ViewReportModal';
import { isAgg } from '../../Common/Helpers';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';

class EmployeeReportTabPanel extends React.Component<EmployeeReportAction & UserEmployeeReportState & RouteComponentProps<{}>, TabsState> {
    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {
            this.props.loadEmployeeSharedReport(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"]);
        }
        else {
            this.props.loadEmployeeReport(this.props.UserState.report_display_id, this.props.UserState.report_vintage_employee);
            this.props.downloadEmployeeDataFiles(this.props.UserState.report_display_id, this.props.UserState.report_vintage_employee);
        }
    }
    render() {
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        const agg = isAgg(this.props.UserState.report_display_id);

        return (
            <div>
                {sharedLinkPageOnLoad ? <ViewReportModal filetype={"Employee"} /> : null}
                <DisclaimerOverlay
                    {...this.props.EmployeeReportState.EmployeeProfileInfo}
                    agg={agg}
                />
                <Tabs>
                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab1'}
                        tabName="Geographic Destinations"
                        arialabel="Opening geographic destinations tab">
                        <GeographicDestinationsTab
                            display_id={this.props.UserState.report_display_id}
                            EmployeeProfileInfo={this.props.EmployeeReportState.EmployeeProfileInfo}
                            EmployeeProfile1={this.props.EmployeeReportState.EmployeeProfile1}
                            EmployeeReport_Tab1={this.props.EmployeeReportState.EmployeeReport_Tab1}
                            agg={agg}
                        />
                    </Tab>
                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}

                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab2'}
                        arialabel="Opening sectors and earnings tab"
                        tabName="Sectors and Earnings">
                        <SectorsEarningsTab
                            display_id={this.props.UserState.report_display_id}
                            EmployeeProfileInfo={this.props.EmployeeReportState.EmployeeProfileInfo}
                            EmployeeProfile2={this.props.EmployeeReportState.EmployeeProfile2}
                            EmployeeReport_Tab2={this.props.EmployeeReportState.EmployeeReport_Tab2}
                            agg={agg}
                            setTab2_bullets={this.props.setTab2_bullets}
                        />
                    </Tab>
                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        arialabel="Opening methodology tab"
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab3'}
                        tabName="Methodology">
                        <EmployeeMethodologyTab
                            EmployeeProfileInfo={this.props.EmployeeReportState.EmployeeProfileInfo}
                            agg={agg}
                        />

                    </Tab>
                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        arialabel="Opening match report tab"
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab4'}
                        tabName="Match Report"
                        shouldShow={!agg}
                    >
                        <EmployeeMatchReportTab
                            display_id={this.props.UserState.report_display_id}
                            EmployeeProfileInfo={this.props.EmployeeReportState.EmployeeProfileInfo}
                            EmployeeMatchRate={this.props.EmployeeReportState.EmployeeMatchRate}
                            EmployeeReport_MatchRateTab={this.props.EmployeeReportState.EmployeeReport_MatchRateTab}
                        />
                    </Tab>
                </Tabs>
            </div>

        );
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadEmployeeReport: loadEmployeeReport,
            loadEmployeeSharedReport: loadEmployeeSharedReport,
            downloadEmployeeDataFiles: downloadEmployeeDataFiles,
            setTab2_bullets: setTab2_bullets
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    EmployeeReportState: state.employeeReportProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(EmployeeReportTabPanel, "Census Supplemental Employee Profile Report","landing page"));

